import { render } from "./my-feed.vue?vue&type=template&id=5456d48f"
import script from "./my-feed.vue?vue&type=script&lang=js"
export * from "./my-feed.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__